export default {
  state: {
    allCountry: [],
    userAddressBook: [],
    departmentsData: [],
    showingDepartmentsData: [],
    mongoliaCity: {},
    mongoliaDistrict: {},
    mongoliaSubistrict: {},
  },
  mutations: {
    setAllCountry(state, payload) {
      state.allCountry = payload
    },
    setAddressBook(state, payload) {
      state.userAddressBook = payload
    },
    setMongoliaCity(state, payload) {
      state.mongoliaCity = payload
    },
    setMongoliaDistrict(state, payload) {
      state.mongoliaDistrict = payload
    },
    setMongoliaSubdistrict(state, payload) {
      state.mongoliaSubistrict = payload
    },
    setDepartmentsData(state, payload) {
      state.departmentsData = payload
      state.showingDepartmentsData = payload.filter(el => el.is_show)
    }
  },
  actions: {
    setAllCountry({commit}, payload) {
      commit('setAllCountry', payload)
    },
    setAddressBook({commit}, payload) {
      commit('setAddressBook', payload)
    },
    setMongoliaCity({commit}, payload) {
      commit('setMongoliaCity', payload)
    },
    setMongoliaDistrict({commit}, payload) {
      commit('setMongoliaDistrict', payload)
    },
    setMongoliaSubdistrict({commit}, payload) {
      commit('setMongoliaSubdistrict', payload)
    },
    setDepartmentsData({commit}, payload) {
      commit('setDepartmentsData', payload)
    }
  },
  getters: {
    getAllCountry(state) {
      return state.allCountry
    },
    getAllCountryIfEmpty(state) {
      return state.allCountry.length
    },
    getAddressBook(state) {
      return state.userAddressBook
    },
    getAddressBookIfEmpty(state) {
      return state.userAddressBook.length
    },
    getMongoliaCity(state) {
      return state.mongoliaCity
    },
    getMongoliaDistrict(state) {
      return state.mongoliaDistrict
    },
    getMongoliaSubdistrict(state) {
      return state.mongoliaSubistrict
    },
    getAddressBookById(state) {
      return idAddressBook => {
        return state.userAddressBook.find(addressBookElement => {
          return addressBookElement.id === +idAddressBook
        })
      }
    },
    getDepartmentsData(state) {
      return state.departmentsData
    },
    getShowingDepartments(state) {
      return state.showingDepartmentsData
    },
  }
}
